import React from "react";
import BaseComponent from "~/components/lib/BaseComponent";
import autosizeInput from "autosize-input";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Loader from "~/components/common/Loader";
import Head from "next/head";
import { store } from "statorgfc";
import _ from "lodash";
import axios from "~/config/axios";
import { facebook } from "~/settings";
import $ from "jquery";
import { css } from "@obby/components";
import { Number__Currency } from "@obby/lib";

export default class Invite extends BaseComponent {
  constructor(props) {
    super(props);
    let defaultValues = {
      emails: [],
      referralCode: "",
      recaptchaResponse: "",
      isLoading: true,
      code: false,
      referrerData: false,
      invitedAndCreditHistory: [],
      signedUp: [],
      bookings: []
    };
    this.state = Object.assign({}, defaultValues, props);
    this._bind(
      "trackInviteSent",
      "verifyRecaptcha",
      "renderNormalUser",
      "renderIsNotLoggedInUser",
      "renderIsUserInvitation"
    );
    store.connectComponentState(this, ["authentication"]);
  }

  static async getInitialProps(context) {
    try {
      const res = await axios.get("Invite");

      return {
        isLoading: false,
        code: false,
        referrerData: res.data.referrerData,
        invitedAndCreditHistory: res.data.invitedAndCreditHistory,
        signedUp: res.data.signedUp
      };
    } catch (error) {
      console.log("error ", error);
      throw error;
    }
  }

  componentDidMount() {
    let dataTrack = {
      name: "Invite Page",
      path: window.location.pathname || "",
      referrer: document.referrer || "",
      title: document.title || "",
      url: window.location.href
    };
    if (window.rudderanalytics)
      window.rudderanalytics.page(dataTrack.name, dataTrack);
  }

  handleAutosizeInput() {
    if (
      this.state.user &&
      typeof autosizeInput !== "undefined" &&
      typeof document !== "undefined"
    ) {
      setTimeout(() => {
        autosizeInput(document.querySelector(".react-tagsinput-input"));
      }, 500);
    }
  }

  handleChange(emails) {
    this.setState({ emails });
  }

  trackInviteSent(sharedVia, emails) {
    if (window.rudderanalytics)
      window.rudderanalytics.track("Invite Sent", {
        shared_via: sharedVia,
        recepient: emails
      });
  }

  popupCenter(url, title, w, h) {
    var dualScreenLeft =
      window.screenLeft != undefined ? window.screenLeft : screen.left;
    var dualScreenTop =
      window.screenTop != undefined ? window.screenTop : screen.top;

    var width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : screen.width;
    var height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : screen.height;

    var left = width / 2 - w / 2 + dualScreenLeft;
    var top = height / 2 - h / 2 + dualScreenTop;
    var newWindow = window.open(
      url,
      title,
      "scrollbars=yes, width=" +
        w +
        ", height=" +
        h +
        ", top=" +
        top +
        ", left=" +
        left
    );

    // Puts focus on the newWindow
    if (window.focus) {
      newWindow.focus();
    }
  }

  recaptchaReady() {
    console.log("reCAPTCHA is ready");
  }

  verifyRecaptcha(recaptchaResponse) {
    this.setState({ recaptchaResponse });
  }

  renderMetadata() {
    const meta = {
      title: "Obby Discount Codes | Invite Your Friends To Obby",
      image: "https://obby.co.uk/static/images/metadata_card.jpg",
      socialTitle: "Get £10 off your first Obby!",
      desc:
        "Join " +
        (this.state.code ? this.state.code.split("-")[0] : "me") +
        " on Obby and find over 1,000+ of London's favourite courses, classes and workshops.",
      url: "https://obby.co.uk/invite" + this.state.code
    };
    return (
      <Head>
        <title>{meta.title}</title>
        <meta name="description" content={meta.desc} />
        <meta property="fb:app_id" content={facebook.appId} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.desc} />
        <meta property="og:url" content={meta.url} />
        <meta property="og:image" content={meta.image} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Obby" />
        <meta property="twitter:title" content={meta.title} />
        <meta property="twitter:description" content={meta.desc} />
        <meta property="twitter:card" content="summary" />
        <meta property="twitter:image" content={meta.image} />
        <meta property="twitter:image:alt" content={meta.title} />
        <link rel="canonical" href={"https://obby.co.uk/invite"} />
      </Head>
    );
  }

  renderNormalUser() {
    return (
      <div className={`invite ${styles.invite}`}>
        {this.renderMetadata()}
        <div className={`invite-container`}>
          <div className={`wording-container ${styles.wordingContainer}`}>
            <h1>Grow the club</h1>
            <h2>Refer a friend. Earn £10.</h2>
            <p>
              Invite your friends to Obby via email, or share your referral code
              on Facebook or Twitter. When you send a friend £10 in Obby credit,
              you’ll get £10 when they book a class. Your available credit
              automatically appears on the checkout page in the form of a
              discount.
            </p>
            <h3>Share your link:</h3>
          </div>
          <div className={`invite-box ${styles.inviteBox}`}>
            <div className={`row share-code ${styles.shareCode}`}>
              <div className="col-md-12 col-sm-8 col-xs-12">
                <span className="code">
                  {`https://obby.co.uk/invite/${this.state.authentication.user.profile.referralCode}` ||
                    "N/A"}
                </span>
                <CopyToClipboard
                  text={
                    `https://obby.co.uk/invite/${this.state.authentication.user.profile.referralCode}` ||
                    "N/A"
                  }
                  onCopy={e => {
                    this.trackInviteSent("Url");
                    $(".btn-copy")[0].innerHTML = "Copied";
                    setTimeout(() => {
                      $(".btn-copy")[0].innerHTML = "Copy";
                    }, 3000);
                  }}
                >
                  <button className="btn-copy">Share</button>
                </CopyToClipboard>
              </div>
              <div className="col-md-6 col-sm-6 col-xs-12">
                <button
                  onClick={() => {
                    this.trackInviteSent("Facebook Messenger");
                    /*
                    this.popupCenter(
                      `https://web.facebook.com/dialog/send?app_id=${Meteor.settings.public.facebook.appId}&link=https://obby.co.uk/invite?${this.state.user.profile.referralCode}&display=popup&redirect_uri=https://obby.co.uk/`,
                      "",
                      "700",
                      "400"
                    );
                    */
                  }}
                  className="messenger"
                >
                  <img
                    className="icon icons8-Facebook-Messenger"
                    width="20"
                    height="20"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAADQElEQVRoQ+2Z/XHUMBDF36sAOoBUAFQAVABUQKgAqICkAkIFkAoCFUAqgFRA0kGoYJnnkTP2WR8r22d7MrczN/fHydb+9HalXR1xT4z3hAMHkK0peVAkpoiZPQfwInweAni6M+4PgFsAv/QheTmXspMVMbPHAD4BeA1AzteYoL4DOCV5XfPg7tjRIAHga1j9KT60z0qld2OBRoGYmRQ4mcP7yDtOSJ7WvrsKxMwUOj8jsV87b2m81HlDUqHnMjeImSlxLwAoJ5YwbQwKNX0XzQUSlPi9IETruDaAZx5liiALhlNq1aXIyxKMB+QMwPuitvsd8IXkh9wUWRAz0+Gm5N6CSRVtAlErgfxdIS9Svl6TPKoGMbNjADrwtmTaxb7FHEoqYmYKKYXWluwHSZVCA4uChPJDYbVFO4qVMSmQOcLqPFS5NeGpZ54UKodoeKVAFIdvJ8hxTlKLAWeuqZxX7aY5m+cydvfu7pgUiLY59RZjbDBRBuZGAEpgM5NyJQj5c0lykLspEBtDACC6WhFl/gE4I9lU0Gamb1XULiM58HtOkCvtcrlSIiij4lMqNJWtM/R6gPsE6UGEShmlynUMhIj2BXIHEQrMzyHWteKqXKMtrJnpPFBbUG01IKo4tQ2WrIEIg1RYqrDr9u3RyjUopgO3tsfXVFckdy814hd0ZqYLgVcFCiWsmiyNU7KmGq4ezEQIuRQ93VPJrpVViKRMEO2+P1idyEMNTIAdq0T72o8k1Vr0N4CYp2HV1BGmTHFf2/JKZT3jAc8Fg/Ju0P7mikY5+6iUJAv/fkMyuoA5kFJ4LczQTBcNK/2QA9GOIlUerOFxZM5mc0kduKUOcUuqJNXIKtKuiJl5z5R9Chc9O7oTem5RlFyCWSvEFFKq4bIXdUUQUa98m6KrU23dWXOBBJg5usaSP7u/Jy8bXAdiajYzWyr5FU7HHiVaX92KLBhiKkQF4bq83iJIr2usjcEtKNIAhNbX/X/I1Bwp3QUrLORM6eJC49o/RIs7kkeduRRprnO6l8yhgt5tnG5rY98D4TrZuy+KnCcDAO/Ec48bq8hmAMbuWipXVIEm/6eYe6W976tSxPvSNcYdQNZY9dyc/wFK1kFCwaR4pAAAAABJRU5ErkJggg=="
                  />
                  <span>Messenger</span>
                </button>
              </div>
              <div className="col-md-6 col-sm-6 col-xs-12">
                <button
                  onClick={() => {
                    this.trackInviteSent("Facebook");
                    /*
                    this.popupCenter(
                      `https://web.facebook.com/dialog/feed?app_id=${Meteor.settings.public.facebook.appId}&display=popup&link=https://obby.co.uk/invite?${this.state.user.profile.referralCode}`,
                      "",
                      "700",
                      "400"
                    );
                    */
                  }}
                  className="facebook"
                >
                  <img
                    className="icon icons8-Facebook-F"
                    width="20"
                    height="20"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABNklEQVRoQ+2W4W3CQAyF39uAblAmgA1KN2ADVgibwAZswAgtG3QERoAJjE5KpIAUrDincofe/b04es/+7DNR+WHl+iEDr66gKvC2FTCzNYAvAEsAK88oyRANoaBnYswsCT4C+PRE9++LMNCK/wEwGyM+fVuKgT8Ai7HiizDQMp/QCZ2XV8DMDgA2IfUlIGRmv+3UGfJwAtCQTJhlO9mmkJmZo2pO8pxNefujfzMQZdwzLANdhjyEVIEBloRQtQh5zHvTo3d/JTl6d+riwwhlNHAi6a7bQwkpwcCeZDOiYneflmBgS3JXs4FvkmmPCp0SKvBB8hJSn7bYaOBjnNfUeon1EjusCaFgM6qJq13mNEaDzD+GqQfUAxNREkJCSAhNzIAQmpjAbFNooo5wuAyEU5cpsPoK3ABda6ExM4MuRgAAAABJRU5ErkJggg=="
                  />
                  <span>Facebook</span>
                </button>
              </div>
            </div>
            <hr />
            <div className={`import-contacts ${styles.importContacts}`}>
              <span>Import contacts:</span>
              <div className="brand">
                <img
                  src="https://png.icons8.com/gmail/color/24"
                  title="Gmail"
                  width="18"
                  height="18"
                />
                Gmail
              </div>
              <div className="separator" />
              <div className="brand">
                <img
                  src="https://png.icons8.com/yahoo/color/24"
                  title="Yahoo"
                  width="18"
                  height="18"
                />
                Yahoo! Mail
              </div>
              <div className="separator" />
              <div className="brand">
                <img
                  src="https://png.icons8.com/microsoft-outlook/color/24"
                  title="Microsoft Outlook"
                  width="18"
                  height="18"
                />
                Outlook
              </div>
            </div>
          </div>
          {this.state.authentication.user &&
            this.state.authentication.user.profile && (
              <p className={`you-have ${styles.youHave}`}>
                So far you have{" "}
                <span className="credit">
                  {Number__Currency(
                    this.state.authentication.user.profile.credit || 0
                  )}
                </span>{" "}
                in learning credit to spend!
              </p>
            )}
          {this.state.invitedAndCreditHistory &&
            this.state.invitedAndCreditHistory.length > 0 && (
              <div className={`features ${styles.features}`}>
                <ul>
                  {this.state.invitedAndCreditHistory.map((el, index) =>
                    el.buyerId ? (
                      <li
                        key={el._id}
                        className={
                          index + 1 ===
                          this.state.invitedAndCreditHistory.length
                            ? "end"
                            : ""
                        }
                      >
                        <div className="left">
                          You used {Number__Currency(el.usedCredit)} for booking{" "}
                          {el._id}
                        </div>
                      </li>
                    ) : el.isExtended &&
                      this.state.signedUp.find(
                        user => user._id === el.userId
                      ) ? (
                      <li
                        key={el.emailAddress + "-credited"}
                        className={
                          index + 1 ===
                          this.state.invitedAndCreditHistory.length
                            ? "end"
                            : ""
                        }
                      >
                        <div className="left">
                          <p>
                            <span className="highlight">
                              {
                                this.state.signedUp.find(
                                  user => user._id === el.userId
                                ).profile.firstName
                              }
                            </span>{" "}
                            completed their first booking, you got £10 in credit
                            🎉
                          </p>
                        </div>
                      </li>
                    ) : (
                      <li
                        key={el.emailAddress + index}
                        className={
                          index + 1 ===
                          this.state.invitedAndCreditHistory.length
                            ? "end"
                            : ""
                        }
                      >
                        <div className="left">
                          {el.existingUser ? (
                            <p>
                              <span className="highlight">
                                {el.emailAddress}
                              </span>{" "}
                              is already an Obby user
                            </p>
                          ) : el.userId &&
                            this.state.signedUp.find(
                              user => user._id === el.userId
                            ) ? (
                            <p>
                              <span className="highlight">
                                {
                                  this.state.signedUp.find(
                                    user => user._id === el.userId
                                  ).profile.firstName
                                }
                              </span>{" "}
                              {this.state.bookings.find(
                                bkg => bkg.buyerId === el.userId
                              )
                                ? "signed up and booked something"
                                : "signed up but did not book anything yet"}
                            </p>
                          ) : (
                            <p>
                              <span className="highlight">
                                {el.emailAddress}
                              </span>{" "}
                              has not signed up yet
                            </p>
                          )}
                        </div>
                        <div className="right">
                          {el.existingUser
                            ? ""
                            : el.userId &&
                              this.state.signedUp.find(
                                user => user._id === el.userId
                              )
                            ? this.state.bookings.find(
                                bkg => bkg.buyerId === el.userId
                              )
                              ? "£10 credited"
                              : "£10 pending"
                            : "£10 pending"}
                        </div>
                      </li>
                    )
                  )}
                </ul>
              </div>
            )}
        </div>
      </div>
    );
  }

  renderIsNotLoggedInUser() {
    return (
      <div className={`invite ${styles.invite}`}>
        {this.renderMetadata()}
        <div className="invite-container">
          <div className={`wording-container ${styles.wordingContainer}`}>
            <h1>Earn Obby discount codes</h1>
            <h2>Refer a friend. Earn £10.</h2>
            <p>
              Invite your friends to Obby via email, or share your referral code
              on Facebook or Twitter. When you send a friend £10 in Obby credit,
              you’ll get £10 when they book a class. Your available credit
              automatically appears on the checkout page in the form of a
              discount.
            </p>
            <button
              onClick={() => {
                $(".menu-item.login")[0].click();
              }}
            >
              Log in to invite friends
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderIsUserInvitation() {
    // goes to the invivation page with the code since we need to support the old links,
    window.location.href = `/invite/${this.state.code}`;
  }

  render() {
    console.log("rendering ", this.state);
    if (this.state.isLoading) {
      return this.renderIsNotLoggedInUser();
    }
    let isNormalUser =
      !_.isEmpty(this.state.authentication.user) && !this.state.code;
    let isNotLoggedInUser =
      _.isEmpty(this.state.authentication.user) &&
      !this.state.code &&
      !this.state.referrerData;
    let isUserInvitation = this.state.code;
    if (isNormalUser) {
      return this.renderNormalUser();
    } else if (isNotLoggedInUser) {
      return this.renderIsNotLoggedInUser();
    } else if (isUserInvitation) {
      return this.renderIsUserInvitation();
    }
    return <Loader />;
  }
}

const styles = {
  invite: css({
    marginTop: "80px",
    marginBottom: "80px",
    padding: "15px",

    hr: {
      margin: "30px auto",
      borderTop: "solid 1px #d8d8d8",
      borderBottom: "none"
    },
    "div.or": {
      position: "relative",
      width: "100%"
    },
    "div.or span": {
      fontSize: "16px",
      fontWeight: "300",
      textAlign: "center",
      background: "white",
      width: "50px",
      position: "absolute",
      bottom: "-22px",
      left: "50%",
      WebkitTransform: "translate(-50%, 0)",
      MsTransform: "translate(-50%, 0)",
      transform: "translate(-50%, 0)"
    }
  }),
  wordingContainer: css({
    textAlign: "center",
    width: "100%",
    color: "#565a5c",

    h3: {
      fontSize: "36px",
      fontWeight: "300"
    },
    p: {
      margin: "0 auto",
      maxWidth: "600px",
      fontSize: "18px",

      a: {
        cursor: "pointer"
      }
    },
    button: {
      outline: "none",
      height: "60px",
      width: "300px",
      borderRadius: "4px",
      border: "none",
      margin: "50px auto",
      fontWeight: "400",
      fontSize: "18px",
      color: "white",
      background: "#00d8c4",
      borderBottom: "3px solid #76e6dd"
    },
    "p.invite-friends": {
      paddingTop: "60px"
    }
  }),
  youHave: css({
    textAlign: "center",
    fontSize: "26px",
    fontWeight: "300",

    ".credit": {
      fontWeight: "400",
      color: "#007986"
    }
  }),
  features: css({
    textAlign: "center",
    maxWidth: "992px",
    margin: "0 auto",

    h3: {
      fontSize: "24px"
    },
    ul: {
      padding: "0",
      width: "100%",
      listStyleType: "none",

      "li.end": {
        borderBottom: "none"
      },

      li: {
        height: "60px",
        paddingTop: "20px",
        borderBottom: "solid 1px #d8d8d8",
        width: "100%",

        ".right": {
          display: "inline",
          float: "right"
        },

        ".left": {
          float: "left",
          display: "inline-block",

          "p .highlight": {
            color: "#007986"
          }
        }
      }
    }
  }),
  inviteBox: css({
    border: "solid 1px #d8d8d8",
    padding: "45px",
    margin: "80px auto",
    maxWidth: "992px",

    "form.sharing-form > button": {
      outline: "none",
      float: "right",
      width: "140px",
      borderTopRightRadius: "4px",
      borderBottomRightRadius: "4px",
      backgroundColor: "#00d8c4",
      border: "none",
      color: "white",
      fontSize: "20px",
      height: "41px"
    },

    "form.sharing-form": {
      width: "100%",
      minHeight: "41px",
      marginBottom: "15px",
      overflow: "auto",

      ".react-tagsinput-remove": {
        cursor: "pointer",
        fontWeight: "bold",
        textDecoration: "none",
        color: "#888888"
      },

      ".react-tagsinput--focused": {
        borderColor: "#00d8c4"
      },

      ".react-tagsinput": {
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        borderTopLeftRadius: "4px",
        borderBottomLeftRadius: "4px",
        overflow: "hidden",
        paddingTop: "5px",
        paddingLeft: "5px",
        width: "calc(100% - 140px)",
        float: "left",
        minHeight: "41px",

        ".react-tagsinput-tag": {
          backgroundColor: "#d8d8d8",
          borderRadius: "2px",
          border: "none",
          color: "#565a5c",
          display: "inline-block",
          fontSize: "13px",
          fontWeight: "400",
          marginBottom: "5px",
          marginRight: "5px",
          padding: "5px",

          "a::before": {
            content: " ×"
          }
        },

        ".react-tagsinput-input": {
          background: "transparent",
          border: "0",
          color: "#777",
          fontSize: "13px",
          fontWeight: "400",
          marginBottom: "6px",
          marginTop: "1px",
          outline: "none",
          padding: "5px",
          width: "100px"
        }
      }
    }
  }),
  shareCode: css({
    "> div": {
      marginBottom: "15px"
    },
    "span.label": {
      lineHeight: "40px"
    },
    "span.code": {
      overflow: "hidden",
      whiteSpace: "nowrap",
      display: "inline-block",
      padding: "10px",
      width: "calc(100% - 60px)",
      border: "dashed 1px #d8d8d8",
      borderRight: "none"
    },
    button: {
      height: "41px",
      outline: "none"
    },
    "button.btn-copy": {
      float: "right",
      width: "60px",
      border: "solid 1px #888888",
      borderLeft: "none",
      background: "#d8d8d8",
      color: "#565a5c",
      borderRadius: "2px"
    },
    "button.messenger": {
      width: "100%",
      borderRadius: "4px",
      border: "none",
      background: "#0084ff",
      color: "white",
      paddingLeft: "15px",
      paddingRight: "15px",

      img: {
        verticalAlign: "middle",
        marginRight: "5px"
      }
    },
    "button.facebook": {
      width: "100%",
      borderRadius: "4px",
      border: "none",
      background: "#3b5998",
      color: "white",
      paddingLeft: "15px",
      paddingRight: "15px",

      img: {
        verticalAlign: "middle",
        marginRight: "5px"
      }
    }
  }),
  importContacts: css({
    display: "none",
    "div.brand": {
      display: "inline",

      img: {
        display: "inline",
        marginBottom: "-3px",
        marginRight: "5px"
      }
    },
    "div.separator": {
      display: "inline",
      height: "15px",
      width: "0",
      marginLeft: "10px",
      marginRight: "10px",
      borderLeft: "solid 1px #d8d8d8"
    },
    span: {
      marginRight: "15px",
      display: "inline"
    }
  })
};
